module.exports = __webpack_public_path__ + "441c90290a48c2d9a074c8474ef989ce.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/head/fox-ears-s.png
// module id = 2810
// module chunks = 0